import createIcon from '../../createIcon';

/**
 * @component @name Pinch
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAyLjVWMUgxMVY2SDkuNVYzLjU2TDMuNTYgOS41SDZWMTFIMVY2SDIuNVY4LjQ0TDguNDQgMi41SDZaTTIyLjk4IDE2LjgyTDIyLjM1IDIxLjI4QzIyLjIxIDIyLjI3IDIxLjM2IDIzIDIwLjM3IDIzSDE0LjIxQzEzLjY4IDIzIDEyLjkyIDIyLjc5IDEyLjU1IDIyLjQxTDggMTcuNjJMOC44MyAxNi43OEM5LjA3IDE2LjU0IDkuNDEgMTYuNDMgOS43NSAxNi41TDEzIDE3LjI0VjYuNUMxMyA1LjY3IDEzLjY3IDUgMTQuNSA1QzE1LjMzIDUgMTYgNS42NyAxNiA2LjVWMTIuNUgxNi45MUMxNy4yMiAxMi41IDE3LjUzIDEyLjU3IDE3LjggMTIuNzFMMjEuODkgMTQuNzVDMjIuNjYgMTUuMTQgMjMuMSAxNS45NyAyMi45OCAxNi44MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Pinch = createIcon('Pinch', [
  [
    'path',
    {
      d: 'M6 2.5V1H11V6H9.5V3.56L3.56 9.5H6V11H1V6H2.5V8.44L8.44 2.5H6ZM22.98 16.82L22.35 21.28C22.21 22.27 21.36 23 20.37 23H14.21C13.68 23 12.92 22.79 12.55 22.41L8 17.62L8.83 16.78C9.07 16.54 9.41 16.43 9.75 16.5L13 17.24V6.5C13 5.67 13.67 5 14.5 5C15.33 5 16 5.67 16 6.5V12.5H16.91C17.22 12.5 17.53 12.57 17.8 12.71L21.89 14.75C22.66 15.14 23.1 15.97 22.98 16.82Z',
      key: 'bhjiaj',
    },
  ],
]);

export default Pinch;
